import React from 'react';

import {FbtBundleConfigContext} from '@udemy-v2/react-bundle-unit';

/**
 * Feeds the redesigned "Frequently Bought Together" bundle config into the shared cart success modal
 * (CartSuccessModal builds FrequentlyBoughtTogether internally, so config flows through context
 * rather than props). Must be an ancestor of every add-to-cart entry point on CLP.
 */
export const FbtBundleConfigProvider = ({children}: {children: React.ReactNode}) => {
    return (
        <FbtBundleConfigContext.Provider
            value={{
                excludeAddedCourseFromBundle: true,
                showPerCardAddToCart: true,
                wideSuccessModal: true,
            }}
        >
            {children}
        </FbtBundleConfigContext.Provider>
    );
};
